export default __webpack_public_path__ + "static/media/password-img.73b5d785.jpg";